import { render, staticRenderFns } from "./reviewItem.vue?vue&type=template&id=192e9ee4"
import script from "./reviewItem.vue?vue&type=script&lang=js"
export * from "./reviewItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports